import * as React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import { ProfileCard } from '../Component';
import { ProfileInfo } from '../Component';

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
        color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        display: { xs: 'block', sm: 'none', md: 'block'},
        fontSize: '1rem',
        fontWeight: '300',
        fontFamily: 'Noto Sans KR',
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default function Profile(props) {
  const { bridal, groom } = props.config;
  return (
    <div align='right' style={{ width: '100%'}}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 0,
          gridTemplateColumns: 'repeat(5, 1fr)',
          justifyContent: 'center',
        }}
      >
        <Item sx={{textAlign:'center', gridRow: '1', gridColumn: '1/6' }}>
          <ProfileInfo profile={bridal} />
        </Item>
        <Item sx={{display: "flex",
                textAlign:'right',
                flexDirection: 'column',
                justifyContent: "center",  
                fontSize: '0.875rem',
                fontWeight: '200',
                gridRow: '2', 
                gridColumn: '1/3'  }}>
          <p>함께하면 더 행복하겠다는 믿음이 생겼습니다</p>
          <p>서로를 소중히 여기며 살겠습니다</p>
        </Item>
        <Item sx={{ gridRow: '2', gridColumn: '3/6'}}>
          <ProfileCard profile={bridal} />
        </Item>
        <Item sx={{textAlign:'center', gridRow: '3', gridColumn: '1/6', marginTop: 8 }}>
          <ProfileInfo profile={groom} />
        </Item>
        <Item sx={{ gridRow: '4', gridColumn: '1/4' }}>
          <ProfileCard profile={groom} />
        </Item>
        <Item sx={{display: "flex",
                textAlign:'left',
                flexDirection: 'column',
                justifyContent: "center",  
                fontSize: '0.875rem',
                fontWeight: '200',
                gridRow: '4', 
                gridColumn: '4/6'  }}>
          <p>내가 아니라 상대방을 행복하게 해주고 싶어졌습니다</p>
          <p>행복하게 살겠습니다</p>
        </Item>
      </Box>
    </div>
  );
}
